import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Link, List, ListItem, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Threads from "../../components/Threads/Threads";

import ThreadList from "../../components/ThreadList/ThreadList";
import { AuthContext } from "../../components/Context/AuthContext";
import ViewDrafts from "../../components/ViewDrafts/ViewDrafts";

const ThreadsPage = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [reload, setReload] = useState(false);
  const [showDrafts, setShowDrafts] = useState(false);
  const [selectedDraft, setSelectedDraft] = useState(null);
  const location = useLocation();
  const draftData = location.state?.draftData || null;
  const handleToggle = () => {
    setShowDrafts((prev) => !prev);
  };
  const handleThreadPosted = () => {
    setShowDrafts(false);
    setSelectedDraft(null);
    setReload((prev) => !prev);
  };

  useEffect(() => {
    document.title = "Post your Question";
  }, []);
  return (
    <Box
      sx={{
        width: "auto",
        margin: "0px auto",
        padding: { xs: "16px", sm: "22px", md: "24px 80px" },
        backgroundColor: "",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 3,
          p: { xs: 2, md: 3 },
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Box>
            <Typography sx={{ fontSize: "1.6rem", fontWeight: 600, mb: 0.5 }}>
              Community Threads
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Ask questions, share updates, and learn from others.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            onClick={() => {
              setShowDrafts((prev) => !prev);
              setSelectedDraft(null);
            }}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              borderRadius: 2,
            }}
          >
            {showDrafts ? "Show All Threads" : "View My Drafts"}
          </Button>
        </Box>
      </Box>

      {/* composer */}
      <Box
        sx={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 3,
          p: { xs: 2, md: 3 },
          mb: 3,
        }}
      >
        <Threads
          userId={user._id}
          onThreadPosted={handleThreadPosted}
          draftData={selectedDraft}
        />
      </Box>

      {showDrafts ? (
        <ViewDrafts
          onEditDraft={(draft) => {
            setSelectedDraft(draft);
            setShowDrafts(false);
          }}
        />
      ) : (
        <ThreadList reload={reload} />
      )}
    </Box>
  );
};

export default ThreadsPage;
